export default "__VITE_ASSET__CEwgInxY__"